export default "__VITE_ASSET__BLNnAmM9__"